var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status === 'loading' || _vm.status === true)?_c('div',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }